var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detai-container main-w"},[_c('Crumbs',{scopedSlots:_vm._u([{key:"current",fn:function(){return [_vm._v(" 关于证书 ")]},proxy:true}])}),_c('div',{ref:"detail",staticClass:"detail-content",staticStyle:{"font-size":"16px"},domProps:{"innerHTML":_vm._s(_vm.certAbout.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }